document.addEventListener('DOMContentLoaded', function () {
    const $nav = $('.anni25_navs');
    const $fixHeight = $('.fix_height');
    const $links = $('.nav_list .nav_item a');
    const $navList = $('.nav_list');
    let navHeight = $nav.outerHeight();
    let targetNavTop = null; // 我们不再在初始化时固定它，而是在未 fixed 时动态记录
    let sections = [];

    // 设置占位高度
    $fixHeight.height(navHeight);

    // 更新 sections 信息
    function updateSections() {
        sections = $links.map(function () {
            const id = $(this).attr('href').slice(1);
            const $section = $(`.${id}`).eq(0);
            if ($section.length) {
                return { id, $el: $section, top: $section.offset().top, height: $section.outerHeight() };
            }
            return null;
        }).get();
    }

    updateSections();

    // 监听 sections 尺寸变化
    function observeSections() {
        sections.forEach(s => {
            const ro = new ResizeObserver(() => {
                s.top = s.$el.offset().top;
                s.height = s.$el.outerHeight();
            });
            ro.observe(s.$el[0]);
        });
    }

    observeSections();

    // 滚动到高亮 nav-item 可见
    function scrollActiveNavItemIntoView() {
        const $active = $navList.find('.nav_item.active');
        if ($active.length) {
            setTimeout(() => {
                $active[0].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
            }, 50);
        }
    }

    // 每次 resize/load 时更新 navHeight 和占位高度
    function updateNavHeight() {
        navHeight = $nav.outerHeight();
        $fixHeight.height(navHeight);
    }
    $(window).on('resize load', updateNavHeight);

    // 核心：获取当前未 fixed 状态下导航在文档中的真实 top
    function computeNavTopWhenNotFixed() {
        // 如果元素不存在直接返回 null
        if (!$nav.length) return null;
        // getBoundingClientRect().top 是相对视口的距离，加上 scrollTop 得到相对于文档顶部的真实位置
        const rectTop = $nav[0].getBoundingClientRect().top;
        const scrollTop = $(window).scrollTop();
        return scrollTop + rectTop;
    }

    // 滚动处理
    function handleScroll() {
        const scrollTop = $(window).scrollTop();
        // 1. 如果当前 nav 还未 fixed，动态记录真实位置（覆盖 targetNavTop）
        //    只有在未 fixed 时记录；当 fixed 后我们保留 targetNavTop，直到解除 fixed 再重新计算。
        if (!$nav.hasClass('fix_top')) {
            const realTop = computeNavTopWhenNotFixed();
            if (realTop != null) {
                targetNavTop = realTop;
            }
        }

        // 2. 吸顶逻辑（基于最新的 targetNavTop）
        if (targetNavTop != null && scrollTop >= targetNavTop) {
            $nav.addClass('fix_top');
            $fixHeight.show();
        } else {
            // 如果回到未 fixed 状态，重新计算并更新 targetNavTop（下次滚动仍能准确）
            if ($nav.hasClass('fix_top')) {
                $nav.removeClass('fix_top');
                $fixHeight.hide();
                // 立即更新 navTop 为当前未 fixed 状态下的位置，防止下一次判断使用旧值
                targetNavTop = computeNavTopWhenNotFixed();
            } else {
                // 保证 targetNavTop 在未 fixed 时也为实时值（覆盖）
                targetNavTop = computeNavTopWhenNotFixed();
            }
        }

        // 3. 计算视口中点并做 section 高亮
        const viewportCenter = scrollTop + window.innerHeight / 2;
        let currentSection = null;
        for (let i = 0; i < sections.length; i++) {
            const s = sections[i];
            const start = s.top;
            const end = s.top + s.height;
            if (viewportCenter >= start && viewportCenter < end) {
                currentSection = s.id;
                break;
            }
        }

        if (currentSection) {
            const $targetLink = $(`.nav_list .nav_item a[href="#${currentSection}"]`);
            const $targetItem = $targetLink.closest('li');
            if (!$targetItem.hasClass('active')) {
                $targetItem.addClass('active').siblings().removeClass('active');
                scrollActiveNavItemIntoView();
            }
        }
    }

    // 初始化时：立即计算一次 navTop（如果用户在脚本加载前已滚动，也会得到正确的实时值）
    targetNavTop = computeNavTopWhenNotFixed();

    // 立即触发一次判断，保证初始状态正确
    handleScroll();

    // 绑定滚动事件（移动端兼容 touchmove）
    $(window).on('scroll touchmove', handleScroll);

    // 点击滚动
    $links.on('click', function (e) {
        e.preventDefault();
        const targetClass = $(this).attr('href').slice(1);
        const $target = $(`.${targetClass}`);
        if ($target.length) {
            const targetTop = $target.offset().top - navHeight - 20;
            $('html,body').animate({ scrollTop: targetTop }, 300, handleScroll);
            history.replaceState(null, null, `#${targetClass}`);
        }
    });
});
